var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"alert alert-warning p-1 mt-2 mb-1"},[_vm._v("\n    "+_vm._s(_vm._f("trans")('revisions.old_value'))+" "+_vm._s(_vm.text)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }